import * as React from "react";
const SvgTableRows = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 8H3V4h18v4zm0 2H3v4h18v-4zm0 6H3v4h18v-4z",
  fill: "currentColor"
}));
export default SvgTableRows;